import { AbodeAggregateMarketConditions, AloftPrice } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { LabelList, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { Typography } from '../../../../summary/components/Typography.tsx';
import { computeTrend } from '../../utils/computeTrend.ts';

export const MedianListPrice = ({
  data,
  disableAnimations = false,
}: {
  data: AbodeAggregateMarketConditions;
  disableAnimations?: boolean;
}) => {
  const chartData: {
    month: string;
    medianListPrice: number;
  }[] = data.monthlyData
    .filter((item) => !!item.median_list_price)
    .map((item) => ({
      month: item.month.substring(0, 7),
      medianListPrice: AloftPrice.schema.parse(item.median_list_price)?.toDollarLike() ?? 0,
    }));
  const maxValue = Math.max(...chartData.map((item) => item.medianListPrice));
  const trendSeries = computeTrend(chartData, 'medianListPrice');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { medianListPrice: 0 }).medianListPrice >=
    (trendSeries[0] || { medianListPrice: 0 }).medianListPrice
      ? '#00B050'
      : '#FF0000';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Median Comp. List Price</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData} margin={{ top: 80, right: 50, left: 0, bottom: 0 }}>
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line
            type="linear"
            dataKey="medianListPrice"
            stroke="#3455DB"
            strokeWidth={2}
            dot={{ r: 3 }}
            isAnimationActive={!disableAnimations}
          >
            <LabelList
              dataKey="medianListPrice"
              position="top"
              fontSize={12}
              offset={10}
              formatter={(value) => AloftPrice.fromDollarLike(Number(value)).toString(true)}
            />
          </Line>
          <Line
            type="linear"
            data={trendSeries}
            dataKey="medianListPrice"
            stroke={trendSeriesColor}
            strokeWidth={1}
            dot={false}
            strokeDasharray="5 5"
            isAnimationActive={!disableAnimations}
          />
        </LineChart>
      </ResponsiveContainer>
    </Flex>
  );
};
